 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A9781440506963_EPUB_COV from '@/components/_9781440506963_epub_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A9781440506963_EPUB_TP from '@/components/_9781440506963_epub_tp'
 import A9781440506963_EPUB_PART1 from '@/components/_9781440506963_epub_part1'
 import A9781440506963_EPUB_ACK from '@/components/_9781440506963_epub_ack'
 import A9781440506963_EPUB_DED from '@/components/_9781440506963_epub_ded'
 import A9781440506963_EPUB_TOC from '@/components/_9781440506963_epub_toc'
 import A9781440506963_EPUB_C1 from '@/components/_9781440506963_epub_c1'
 import A9781440506963_EPUB_C2 from '@/components/_9781440506963_epub_c2'
 import A9781440506963_EPUB_C2A from '@/components/_9781440506963_epub_c2a'
 import A9781440506963_EPUB_C3 from '@/components/_9781440506963_epub_c3'
 import A9781440506963_EPUB_C4 from '@/components/_9781440506963_epub_c4'
 import A9781440506963_EPUB_C6 from '@/components/_9781440506963_epub_c6'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/_9781440506963_epub_cov",
 			"name" : "_9781440506963_epub_cov",
 			"component" : A9781440506963_EPUB_COV
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/_9781440506963_epub_tp",
 			"name" : "_9781440506963_epub_tp",
 			"component" : A9781440506963_EPUB_TP
 		},
 		{
 			"path" : "/_9781440506963_epub_part1",
 			"name" : "_9781440506963_epub_part1",
 			"component" : A9781440506963_EPUB_PART1
 		},
 		{
 			"path" : "/_9781440506963_epub_ack",
 			"name" : "_9781440506963_epub_ack",
 			"component" : A9781440506963_EPUB_ACK
 		},
 		{
 			"path" : "/_9781440506963_epub_ded",
 			"name" : "_9781440506963_epub_ded",
 			"component" : A9781440506963_EPUB_DED
 		},
 		{
 			"path" : "/_9781440506963_epub_toc",
 			"name" : "_9781440506963_epub_toc",
 			"component" : A9781440506963_EPUB_TOC
 		},
 		{
 			"path" : "/_9781440506963_epub_c1",
 			"name" : "_9781440506963_epub_c1",
 			"component" : A9781440506963_EPUB_C1
 		},
 		{
 			"path" : "/_9781440506963_epub_c2",
 			"name" : "_9781440506963_epub_c2",
 			"component" : A9781440506963_EPUB_C2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js